



















import { Component, Prop, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import TimePicker from '@/componentsV2/molecules/TimePicker/TimePicker.vue';

@Component({
  components: { Typography, TimePicker }
})
export default class HourPeriod extends Vue {
  @Prop() error?: boolean;
  @Prop() value?: string;

  valueFrom: string = '';
  valueTo: string = '';

  click(e: any) {
    e.preventDefault();
  }

  changeFromTime(time: string) {
    this.$emit('inputFrom', time);
  }

  changeToTime(time: string) {
    this.$emit('inputTo', time);
  }

  created() {
    if (this.value) {
      const [from, to] = this.value.split(',');
      this.valueFrom = from.replace(from.slice(-3), '');
      this.valueTo = to.replace(to.slice(-3), '');
    }
  }
}
